import { Component, OnInit } from '@angular/core';
import { Client } from '../../../interfaces/Client.interface';
import { $ } from 'protractor';

@Component({
  selector: 'app-compensation',
  templateUrl: './compensation.component.html',
  styleUrls: ['./compensation.component.css']
})
export class CompensationComponent implements OnInit {

  public help1:boolean;
  public help2:boolean;
  public infoClient:Client;
  public src:string;
  public srcOthers:string;
  public others:boolean;
  public icon1:boolean;
  public icon2: boolean;
  public actualLanguage: string;

  constructor() {

    this.help1=false;
    this.help2=false;
    this.others=false;
    this.icon1=false;
    this.icon2=false;
    

   }

  ngOnInit() {

    if(localStorage.getItem('infoClient')){
      this.infoClient=JSON.parse(localStorage.getItem('infoClient'));
    }

    if(sessionStorage.getItem('lang')){
      console.log("INSIDE");
      console.log(sessionStorage.getItem('lang'));
      this.actualLanguage = sessionStorage.getItem('lang');
    }

    setInterval(()=>{
      this.actualLanguage = sessionStorage.getItem('lang');
    this.setStringSrc();
    },500);
  }

  /**
   * Funcion para abrir etiqueta de ayuda
   */
  public showHelp(type:number){
    console.log('entra abre');
    
    if(type===1){
      this.help1=true;
      this.help2=false;
    }else if(type===2){
      this.help1=false;
      this.help2=true;
    }
  }

  /**
   * Funcion para cerrar etiqueta de ayuda
   */
  public closeHelp(){
    console.log('entra cierra');
    this.help1=false;
    this.help2=false;
  }


  public setStringSrc(){

    switch(this.infoClient.category.id){
      
      
      case '1':
          if(this.infoClient.level.id==='1'){
            this.icon1=true;
            this.icon2=true;
            this.src='../../../../assets/images/tab_suministrador_' + this.actualLanguage + '.png';
          }else if(this.infoClient.level.id==='2'){
            this.icon1=true;
            this.icon2=true;
            this.src='../../../../assets/images/tab_suministrador_' + this.actualLanguage + '.png';
          }else if(this.infoClient.level.id==='3'){
            this.icon1=true;
            this.icon2=true;
            this.src='../../../../assets/images/tab_suministrador_' + this.actualLanguage + '.png';
          }
      break;
      case '2':
      // $('.info1').css('margin-top','0px');
          if(this.infoClient.level.id==='4'){
            this.icon1=true;
            this.others=true;
            this.src='../../../../assets/images/tab_asociacion_platino_y_oro_' + this.actualLanguage + '.png';
            this.srcOthers='../../../../assets/images/tab_otros_beneficios_asoc_platino_' + this.actualLanguage + '.png';
          }else if(this.infoClient.level.id==='5'){
            this.icon1=true;
            this.src='../../../../assets/images/tab_asociacion_platino_y_oro_' + this.actualLanguage + '.png';
          }else if(this.infoClient.level.id==='6'){
            this.icon1=true;
            this.src='../../../../assets/images/tab_asociacion_bronce_' + this.actualLanguage + '.png';
          }else if(this.infoClient.level.id==='8'){
            this.icon1=true;
            this.src='../../../../assets/images/tab_asociacion_platino_y_oro_' + this.actualLanguage + '.png';
          }
      break;
      case '3':

          if(this.infoClient.level.id==='7'){
            
            this.src='../../../../assets/images/tab_aprovechamiento_' + this.actualLanguage + '.png'
          }
      break;
    }
    
  }

}
